import get from 'lodash.get';

export const selectCurrentUser = (state) => get(state, 'user.information');
